import {FulfillmentStatus, RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';
import switchPanes from 'util/switchPanes';

import {ExecutionType, PANE_ORDER, PaneKey} from './ExecuteRequestFlowConstants';
import {ExecuteRequestFlowAction, ExecuteRequestFlowActionType} from './ExecuteRequestFlowReduxActions';
import reduceExistingEntry, {ExistingEntryState} from './existing-entry/reduceExistingEntry';

const EXECUTE_REQUEST_FLOW_INITIAL_STATE: ExecuteRequestFlowState = {
  excludedPanes: [],
  executionType: null,
  paneKey: null,
  selectedFulfillmentDefinitions: null,
  selectedExecutedFulfillmentDefinitions: [],
  statusFilter: null,
};

export interface ExecuteRequestFlowState {
  excludedPanes: Array<PaneKey>;
  executionType: ExecutionType | null;
  paneKey: PaneKey | null;
  selectedFulfillmentDefinitions: Array<RequestFulfillmentDefinition> | null;
  selectedExecutedFulfillmentDefinitions: Array<RequestFulfillmentDefinition>;
  statusFilter: FulfillmentStatus | null;
  existingEntry?: ExistingEntryState;
}

function switchExecutePanes(paneArgs: {
  currentPaneKey: PaneKey | null;
  excludedPanes: Array<PaneKey>;
  offset: -1 | 1;
}): PaneKey {
  return switchPanes<PaneKey>(PANE_ORDER, paneArgs);
}

export default function reduceExecuteRequestFlow(
  state: ExecuteRequestFlowState = EXECUTE_REQUEST_FLOW_INITIAL_STATE,
  action: ExecuteRequestFlowAction
): ExecuteRequestFlowState {
  state = {
    ...state,
    existingEntry: reduceExistingEntry(state.existingEntry, action),
  };
  switch (action.type) {
    case ExecuteRequestFlowActionType.OPEN_EXECUTE_REQUEST_FLOW: {
      const {excludedPanes, paneKey} = action;
      return {
        ...state,
        excludedPanes,
        paneKey,
      };
    }
    case ExecuteRequestFlowActionType.CLOSE_EXECUTE_REQUEST_FLOW:
      return {...state, ...EXECUTE_REQUEST_FLOW_INITIAL_STATE};
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_PREV_PANE: {
      const newPaneKey = switchExecutePanes({
        currentPaneKey: state.paneKey,
        excludedPanes: state.excludedPanes,
        offset: -1,
      });
      return {...state, paneKey: newPaneKey};
    }
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_NEXT_PANE: {
      const newPaneKey = switchExecutePanes({
        currentPaneKey: state.paneKey,
        excludedPanes: state.excludedPanes,
        offset: +1,
      });
      return {...state, paneKey: newPaneKey};
    }
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_FULFILLMENT_DEFINITIONS: {
      const {fulfillmentDefinitions} = action;
      return {...state, selectedFulfillmentDefinitions: fulfillmentDefinitions};
    }
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_EXECUTED_FULFILLMENT_DEFINITIONS: {
      const {fulfillmentDefinitions} = action;
      return {...state, selectedExecutedFulfillmentDefinitions: fulfillmentDefinitions};
    }
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_STATUS_FILTER: {
      const {statusFilter} = action;
      return {...state, statusFilter};
    }
    case ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_EXECUTION_TYPE: {
      const {executionType} = action;
      return {...state, executionType};
    }
    default:
      return state;
  }
}
